import {Lock, lockCallback} from '@gongxigames/framework/core/fragments/locker/Lock';
import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';

export class LockManager {
    private locks: Map<string, Lock> = new Map();

    public add(name: string, onChangeLock: lockCallback): this {
        if (this.locks.has(name)) {
            consoleLogger.error(`LockManager: element '${name}' already added...`);
        }

        this.locks.set(name, new Lock(onChangeLock));

        return this;
    }

    public delete(name: string): this {
        this.locks.delete(name);

        return this;
    }

    public unlockAll(reason: symbol): void {
        this.locks.forEach(item => item.unlock(reason) );
    }

    public lockAll(reason: symbol): void {
        this.locks.forEach(item => item.lock(reason) );
    }

    public unlock(name: string, reason: symbol | string): void {
        const lockItem = this.locks.get(name);

        if (lockItem) {
            lockItem.unlock(reason);
        } else {
            consoleLogger.error(`Error: try to unlock unknown item: ${name}`);
        }
    }

    public lock(name: string, reason: symbol | string): void {
        const lockItem = this.locks.get(name);

        if (lockItem) {
            lockItem.lock(reason);
        } else {
            consoleLogger.error(`Error: try to lock unknown item: ${name}`);
        }
    }

    public getLock(name: string): Lock {
        return this.locks.get(name)!;
    }
}
